export const amountData = {
    methods: {
        numberFormat(number) {
            if (number < 1e4) {
                number = this.thousandFormat(number);
                return `${number}`
            }
            if (number >= 1e4 && number < 1e8) {
                if (number > 1e5) {
                    number = Math.floor((number / 1e4))
                } else {
                    number = Math.round((number / 1e4) * 10) / 10;
                }
                number = this.thousandFormat(number);
                return `${number}万`
            }
            if (number >= 1e8 && number < 1e12) {
                if (number > 1e9) {
                    number = Math.floor((number / 1e8))
                } else {
                    number = Math.round((number / 1e8) * 10) / 10;
                }
                number = this.thousandFormat(number);
                return `${number}亿`
            }
            if (number >= 1e12 && number < 1e16) {
                if (number > 1e13) {
                    number = Math.floor((number / 1e12))
                } else {
                    number = Math.round((number / 1e12) * 10) / 10;
                }
                number = this.thousandFormat(number);
                return `${number}兆`
            }
            if (number >= 1e16 && number < 1e20) {
                if (number > 1e17) {
                    number = Math.floor((number / 1e16))
                } else {
                    number = Math.round((number / 1e16) * 10) / 10;
                }
                number = this.thousandFormat(number);
                return `${number}京`
            }
        },
        thousandFormat(number) {
            // console.log(number)
            if (number >= 1000) {
                let numberArr = String(number).split("");
                if (numberArr.length == 4) {
                    for (var i = numberArr.length - 1; i >= 1; i--) {
                        numberArr[i + 1] = numberArr[i];
                    }
                    numberArr[1] = ","
                }
                numberArr = numberArr.join("");
                return numberArr;
            } else {
                return number;
            }
        },
        numbetToTag(number) {
            if (number > 0 && number < 10) {
                return 'files-one'
            }
            if (number > 10 && number < 100) {
                return 'files-ten'
            }
            if (number > 100 && number < 1000) {
                return 'files-hundred'
            }
            if (number > 1000 && number < 10000) {
                return 'files-thousand'
            }
            if (number > 10000 && number < 50000) {
                return 'files-tenthousand'
            }
            if (number > 50000 && number < 100000) {
                return 'files-fiftythousand'
            }
            if (number > 100000 && number < 1000000) {
                return 'files-onehundredthousand'
            }
            if (number > 1000000) {
                return 'files-million'
            }
        },
        rankFormat(rank) {
            if (rank > 50) {
                return "50+"
            }
            return rank
        },
        fractionFormat(number) {
            return Math.round((number / 100) * 10) / 10;
        },
        timeFormat(time) {
            if (time <= 60) {
                return `${time}秒前`
            }
            if (time > 60 && time <= 3600) {
                return `${parseInt(time / 60)}分钟前`
            }
            if (time > 3600 && time <= 86400) {
                return `${parseInt(time / 3600)}小时前`
            }
            if (time > 86400) {
                return `${parseInt(time / 86400)}天前`
            }
        }
    }
};